import { api, BaseAPI } from '@services/api';

class API extends BaseAPI {
  constructor() {
    super('localization/city');
  }
  timezone = async () => {
    return api.get(this.buildUrl('timezone'));
  };
}

export default new API();
